var map = {
	"./template.bet575": 1525,
	"./template.bet575.tsx": 1525,
	"./template.bet777": 1527,
	"./template.bet777.tsx": 1527,
	"./template.betgalaxy": 1528,
	"./template.betgalaxy.tsx": 1528,
	"./template.betprofessor": 1529,
	"./template.betprofessor.tsx": 1529,
	"./template.betroyale": 1530,
	"./template.betroyale.tsx": 1530,
	"./template.betstride": 1531,
	"./template.betstride.tsx": 1531,
	"./template.buffalobet": 1532,
	"./template.buffalobet.tsx": 1532,
	"./template.chromabet": 1533,
	"./template.chromabet.tsx": 1533,
	"./template.default": 716,
	"./template.default.tsx": 716,
	"./template.epicodds": 1534,
	"./template.epicodds.tsx": 1534,
	"./template.fiestabet": 1535,
	"./template.fiestabet.tsx": 1535,
	"./template.forsport": 1536,
	"./template.forsport.tsx": 1536,
	"./template.gigabet": 1537,
	"./template.gigabet.tsx": 1537,
	"./template.goldenbet888": 2063,
	"./template.goldenbet888.tsx": 2063,
	"./template.goldenrush": 1538,
	"./template.goldenrush.tsx": 1538,
	"./template.hyperbet": 1539,
	"./template.hyperbet.tsx": 1539,
	"./template.juicybet": 1540,
	"./template.juicybet.tsx": 1540,
	"./template.junglebet": 1541,
	"./template.junglebet.tsx": 1541,
	"./template.magnumbet": 1542,
	"./template.magnumbet.tsx": 1542,
	"./template.oldgill": 1543,
	"./template.oldgill.tsx": 1543,
	"./template.puntcity": 1544,
	"./template.puntcity.tsx": 1544,
	"./template.puntgenie": 1545,
	"./template.puntgenie.tsx": 1545,
	"./template.pyramidbet": 1546,
	"./template.pyramidbet.tsx": 1546,
	"./template.questbet": 1547,
	"./template.questbet.tsx": 1547,
	"./template.slambet": 1548,
	"./template.slambet.tsx": 1548,
	"./template.sterlingparker": 1549,
	"./template.sterlingparker.tsx": 1549,
	"./template.sugarcastle": 1550,
	"./template.sugarcastle.tsx": 1550,
	"./template.templebet": 1551,
	"./template.templebet.tsx": 1551,
	"./template.titanbet": 1552,
	"./template.titanbet.tsx": 1552,
	"./template.ts": 978,
	"./template.vikingbet": 1553,
	"./template.vikingbet.tsx": 1553,
	"./template.volcanobet": 1554,
	"./template.volcanobet.tsx": 1554,
	"./template.wellbet": 1555,
	"./template.wellbet.tsx": 1555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2444;